import { render, staticRenderFns } from "./OutpatientCareDetail.vue?vue&type=template&id=0b6b20d8&scoped=true&"
import script from "./OutpatientCareDetail.vue?vue&type=script&lang=js&"
export * from "./OutpatientCareDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b20d8",
  null
  
)

export default component.exports